import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Exams from "@/pages/Exams";
import CreateExam from "@/pages/CreateExam";
import Questions from "@/pages/Questions";
import AnswerKey from "@/pages/AnswerKey";
import Students from "@/pages/Students";
import Classes from "@/pages/Classes";
import OpticalForms from "@/pages/OpticalForms";
import OpticalReader from "@/pages/OpticalReader";
import Results from "@/pages/Results";
import ClassAnalytics from "@/pages/ClassAnalytics";
import StudentAnalytics from "@/pages/StudentAnalytics";
import KttAnalytics from "@/pages/KttAnalytics";
import ParentNotifications from "@/pages/ParentNotifications";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Register from "@/pages/Register";
import Locked from "@/pages/Locked";
import Orgs from "@/pages/Orgs";
import Guide from "@/pages/Guide";

function Protected({ children }) {
  const { user, booted, locked } = useAuth();
  if (!booted) return <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">Yükleniyor...</div>;
  if (!user) return <Navigate to="/giris" replace />;
  if (locked && user.platform_role !== "superadmin") return <Locked />;
  return children;
}

function SuperOnly({ children }) {
  const { user } = useAuth();
  if (user?.platform_role !== "superadmin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<Login />} />
            <Route path="/kayit" element={<Register />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/kurumlar" element={<SuperOnly><Orgs /></SuperOnly>} />
              <Route path="/sinavlar" element={<Exams />} />
              <Route path="/sinav-olustur" element={<CreateExam />} />
              <Route path="/sinav/:examId/sorular" element={<Questions />} />
              <Route path="/sinav/:examId/cevap-anahtari" element={<AnswerKey />} />
              <Route path="/sinav/:examId/optik-formlar" element={<OpticalForms />} />
              <Route path="/sinav/:examId/optik-oku" element={<OpticalReader />} />
              <Route path="/sinav/:examId/sonuclar" element={<Results />} />
              <Route path="/ogrenciler" element={<Students />} />
              <Route path="/siniflar" element={<Classes />} />
              <Route path="/optik-okuma" element={<OpticalReader />} />
              <Route path="/sinif-analizi" element={<ClassAnalytics />} />
              <Route path="/ogrenci-analizi" element={<StudentAnalytics />} />
              <Route path="/analiz" element={<KttAnalytics />} />
              <Route path="/veli-bildirimleri" element={<ParentNotifications />} />
              <Route path="/raporlar" element={<Reports />} />
              <Route path="/ayarlar" element={<Settings />} />
              <Route path="/kilavuz" element={<Guide />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" className="no-print" />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
